import { createTheme as s } from "../../_mixins/use-theme.js";
import u from "./_common.js";
import H from "../../_styles/common/light.js";
import B from "../../popover/styles/light.js";
import { changeColor as I } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/color/index.js";
function T(r) {
  const {
    primaryColor: o,
    textColor2: e,
    dividerColor: t,
    hoverColor: i,
    popoverColor: n,
    invertedColor: l,
    borderRadius: p,
    fontSizeSmall: d,
    fontSizeMedium: C,
    fontSizeLarge: v,
    fontSizeHuge: a,
    heightSmall: m,
    heightMedium: g,
    heightLarge: h,
    heightHuge: c,
    textColor3: f,
    opacityDisabled: x
  } = r;
  return Object.assign(Object.assign({}, u), {
    optionHeightSmall: m,
    optionHeightMedium: g,
    optionHeightLarge: h,
    optionHeightHuge: c,
    borderRadius: p,
    fontSizeSmall: d,
    fontSizeMedium: C,
    fontSizeLarge: v,
    fontSizeHuge: a,
    // non-inverted
    optionTextColor: e,
    optionTextColorHover: e,
    optionTextColorActive: o,
    optionTextColorChildActive: o,
    color: n,
    dividerColor: t,
    suffixColor: e,
    prefixColor: e,
    optionColorHover: i,
    optionColorActive: I(o, {
      alpha: 0.1
    }),
    groupHeaderTextColor: f,
    // inverted
    optionTextColorInverted: "#BBB",
    optionTextColorHoverInverted: "#FFF",
    optionTextColorActiveInverted: "#FFF",
    optionTextColorChildActiveInverted: "#FFF",
    colorInverted: l,
    dividerColorInverted: "#BBB",
    suffixColorInverted: "#BBB",
    prefixColorInverted: "#BBB",
    optionColorHoverInverted: o,
    optionColorActiveInverted: o,
    groupHeaderTextColorInverted: "#AAA",
    optionOpacityDisabled: x
  });
}
const A = s({
  name: "Dropdown",
  common: H,
  peers: {
    Popover: B
  },
  self: T
}), w = A;
export {
  w as default,
  T as self
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/dropdown/styles/light.js
// module id = 914
// module chunks = 41